<template>
<div>
    <el-dialog :title="title" class="c-dialog-fixed" width="700px" :visible.sync="show" :append-to-body="inDialog" :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" center top="5vh" @open="openDialog" @close="closeDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="mini" status-icon class="c-form-mini">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="国家:" prop="country">
                        <el-select v-model="form.country" placeholder="请选择国家" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option @change="handleChange">
                            <el-option v-for="item in countrylist" :key="item.id" :label="item.title" :value="item.title" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="一级地区:" prop="region">
                        <el-select v-model="form.region" placeholder="请选择地区" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option @click.native="havaCountry()" @change="handleChange2">
                            <el-option v-for="item in regionlist" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="二级地区:" prop="region">
                        <el-select v-model="form.region2" placeholder="请选择地区" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option @click.native="havaregion()" >
                            <el-option v-for="item in region2list" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="备注:" prop="remark">
                        <el-input v-model="form.remark" type="primary" style="width: 200px" placeholder="请输入备注" />
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="show = false">
                取消
            </el-button>
            <el-button type="primary" @click="title === '添加记录' ? addData() : editData()">
                确认
            </el-button>
        </div>
    </el-dialog>

</div>
</template>

<script>
import {
    country_list_all,
    entity_list_getRegion,
    region_add,
    region_edit,
    region_list_getRegionByCountry,
    region_list_getRegion2ByRegion
} from '../../api';

const formInit = {
    country: '', //国家
    region: '', //地区
    remark: '', //备注
}
export default {
    name: 'AddDetail',
    // directives: { waves },
    components: {

    },
    props: {
        module: {
            type: String,
            default: ''
        },
        inDialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: '新增',
            areaChildLocation: [],
            countrylist: [],
            projectTypeOnes: [],
            loading: false,
            form: {
                ...formInit
            },
            isPublicOption: [],
            partyOption: [],
            languageOption: [],
            religionlist: [],
            region2list: [],
            regionlist: [],
            show: false,
            updated: false,
            nowUser: '',

            lander: {},
            file: {},
            query: {},

            rules: {
                itemcode: [{
                    required: true,
                    pattern: /^\d{13}$/,
                    message: '请输入13位纯数字物料编码',
                    trigger: ''
                }],

            }
        }
    },
    // created() {
    //   this.getItems()
    // },
    mounted() {
        this.nowUser = localStorage.getItem('account')
        this.lander = JSON.parse(this.$store.state.logininfo);
        // this.getItems();
        this.getCountry();
    },
    methods: {

        //获取国家清单数据
        getCountry() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            country_list_all(this.query).then((res) => {
                if (res.data.status == 1) {
                    this.countrylist = res.data.obj
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        havaCountry() {
            if (this.form.country == '' || this.form.country == null) {
                this.$message.error('请先选择国家')
            }

        },
        havaregion() {
            if (this.form.region == '' || this.form.region == null) {
                this.$message.error('请先选择一级地区')
            }
        },

        openDialog() {
            this.$nextTick(() => {
                if (this.resolve) {
                    this.resolve(this)
                }
            })
        },
        open() {
            this.show = true
            this.getCountry()
            return new Promise((resolve, reject) => {
                this.resolve = resolve
            })
        },
        clearValidate() {
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate()
            })
        },
        resetFields() {
            this.updated = false
            this.form = {
                ...formInit
            }
            this.clearValidate()
            return this
        },
        closeDialog() {
            const vm = this
            vm.form = {
                ...formInit
            }
            this.resetFields()
        }, // 关闭弹窗操作
        update() {
            this.loading = false
            this.updated = true
            this.show = false
            this.$emit('addRefresh')
            this.resetFields()
        },
        handleChange() {
            this.regionlist = null;
            this.query.region = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.query.country == this.form.country
            region_list_getRegionByCountry(this.query).then((response) => {
                this.regionlist = response.data.obj
            })
        },
        handleChange1() {
            if (this.form.country == '' || this.form.country == null) {
                this.$message.error('请先选择国家')
            }
            this.regionlist = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.query.country == this.form.country
            region_list_getRegionByCountry(this.query).then((response) => {
                this.regionlist = response.data.obj
            })
        },

        updateForEdit() {
            this.$parent.$emit('addRefresh')
            this.loading = false
            this.updated = true
            this.show = false
            this.resetFields()
        },
        initData(data, title) {
            if (title == 'add') {
                this.title = "添加记录"
            } else {
                this.title = "编辑数据"
            }
            this.assign(data)
            this.clearValidate()
        },
        assign(data) {
            this.form = {
                ...this.form,
                ...data
            }
            return this
        },

        handleChange2() {
            this.region2list = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.query.region = this.form.region
            region_list_getRegion2ByRegion(this.query).then((response) => {
                this.region2list = response.data.obj
            })
        },
        addData() {
            this.$refs['form'].validate(() => {
                this.form.uid = this.lander.uid;
                this.form.token = this.lander.token;
                region_add(this.form).then((res) => {
                    this.$notify({
                        title: '成功',
                        message: '编辑成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.update()
                })

            })
        },
        editData() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.form.uid = this.lander.uid;
                    this.form.token = this.lander.token;
                    region_edit(this.form).then((res) => {
                        this.$notify({
                            title: '成功',
                            message: '编辑成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.update()
                    })
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
</style>
